import React, { Component } from "react";
import { Card, Input, Button, Form, notification } from "antd/lib/index";
import { Field, Formik } from "formik";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { getAuthTokenAndAddProfessor } from "../../../../redux/actions/users";
import { CustomLogger } from "../../../../utils/CustomLogger";

const generator = require("generate-password");

const CustomInputComponent = ({ field, ...props }) => {
  return (
    <Form.Item label={props.label}>
      <Input type={props.type ? props.type : "text"} {...field} {...props} />
    </Form.Item>
  );
};

class CreateProfessorForm extends Component {
  openNotificationWithIcon = type => {
    notification[type]({
      message: "Profesor añadido exitosamente"
    });
  };

  render() {
    CustomLogger({ ComponentName: "CreateProfessorForm", ...this.props });

    return (
      <Card>
        <Formik
          initialValues={{
            nombre: "",
            email: "",
            colegio: "",
            rut: ""
          }}
          onSubmit={(values, { setStatus }) => {
            const normalized = {
              ...values,
              password: generator.generate({
                length: 8
              })
            };
            this.props.getAuthTokenAndAddProfessor(normalized, setStatus);
          }}
          render={props => (
            <Card>
              {props.status &&
                props.status.success &&
                this.openNotificationWithIcon("success")}
              <Form>
                <Field
                  label="Nombre"
                  name="nombre"
                  component={CustomInputComponent}
                />
                <Field
                  label="Colegio"
                  name="colegio"
                  component={CustomInputComponent}
                />
                <Field
                  type="email"
                  label="Email"
                  name="email"
                  component={CustomInputComponent}
                />
                <Field
                  label="Rut"
                  name="rut"
                  component={CustomInputComponent}
                />
                <Button onClick={props.handleSubmit}>Submit</Button>
              </Form>
            </Card>
          )}
        />
      </Card>
    );
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators({ getAuthTokenAndAddProfessor }, dispatch);

export default connect(
  null,
  mapDispatchToProps
)(CreateProfessorForm);
